// import React, { useState, useRef, useEffect, useContext } from "react";
// import { BiBell } from "react-icons/bi";
// import { FaTimes } from "react-icons/fa";
// import { IoIosClose } from "react-icons/io";
// import { TiTick } from "react-icons/ti";
// import { useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import ApiUrl from "../Environment/ApiUrl";
// import { RatesContext } from "../Pages/RatesContext";
// import "../../assets/css/Navbar.css";

// const Navbar = ({ collapsed }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const context = useContext(RatesContext);
//   const rates = context?.rates || {
//     gold_1g_rate: "Loading...",
//     silver_10g_rate: "Loading...",
//     cold_coin_rate: "Loading...",
//   };
//   const [showNotifications, setShowNotifications] = useState(false);
//   const [showProfile, setShowProfile] = useState(false);
//   const [isProcessing, setIsProcessing] = useState(false);
//   const notificationsRef = useRef(null);
//   const profileRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         notificationsRef.current &&
//         !notificationsRef.current.contains(event.target)
//       ) {
//         setShowNotifications(false);
//       }
//       if (profileRef.current && !profileRef.current.contains(event.target)) {
//         setShowProfile(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const getPageTitle = () => {
//     const path = location.pathname.split("/")[1];
//     return path.charAt(0).toUpperCase() + path.slice(1).replace(/-/g, " ");
//   };

//   const handleCloseNotifications = () => {
//     setShowNotifications(false);
//   };

//   const [getitem, setItem] = useState();
//   const [role, setRole] = useState();

//   useEffect(() => {
//     const username = localStorage.getItem("username");
//     const role = localStorage.getItem("role");
//     setItem(username);
//     setRole(role);
//   }, []);

//   const [responseNotification, setResponseNotification] = useState([]);

//   const fetchNotification = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/notification.php`);
//       setResponseNotification(response.data?.data || []);
//     } catch (error) {
//       console.log("Error fetching notifications:", error.message);
//     }
//   };

//   useEffect(() => {
//     fetchNotification();
//     const interval = setInterval(fetchNotification, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   const filteredNotifications = responseNotification.filter((notification) => {
//     if (role === "Employee") {
//       return (
//         notification.employe_id === getitem &&
//         (notification.status.toLowerCase() === "accepted" ||
//           notification.status.toLowerCase() === "rejected")
//       );
//     } else if (role === "Admin") {
//       return notification.status.toLowerCase() === "requested";
//     }
//     return false;
//   });

//   const unreadNotificationsCount = filteredNotifications.filter(
//     (notification) => notification.viewed !== "true"
//   ).length;

//   const getStatusBackgroundColor = (status) => {
//     switch (status.toLowerCase()) {
//       case "requested":
//         return "#FFC107";
//       case "accepted":
//         return "#4CAF50";
//       case "rejected":
//         return "#F44336";
//       default:
//         return "#FFFFFF";
//     }
//   };

//   const handleNotificationClick = (tableName) => {
//     let path;
//     switch (tableName.toLowerCase()) {
//       case "sales":
//         path = "/sales";
//         break;
//       case "loan":
//         path = "/loan";
//         break;
//       case "daily_rates":
//         path = "/daily_rates";
//         break;
//       case "product":
//         path = "/product";
//         break;
//       default:
//         path = "/";
//         break;
//     }
//     navigate(path);
//     setShowNotifications(false);
//   };

//   const [bulkAction, setBulkAction] = useState(null);

//   const handleBulkAction = async (action, notificationId = null) => {
//     const validActions = ["accept", "reject"];
//     if (!action || !validActions.includes(action)) {
//       alert("Please select a valid action (Accept or Reject).");
//       return;
//     }

//     if (!notificationId && filteredNotifications.length === 0) {
//       alert("No notifications to process.");
//       return;
//     }

//     if (isProcessing) return;
//     setIsProcessing(true);

//     try {
//       let notificationIds = notificationId
//         ? [notificationId]
//         : filteredNotifications.map((notification) => notification.id);

//       const response = await axios.put(`${ApiUrl}/Api/notification.php`, {
//         status: action === "accept" ? "accepted" : "rejected",
//         notificationIds,
//         updated_by: getitem,
//       });

//       if (response.data.success) {
//         await fetchNotification();
//         if (!notificationId) setBulkAction(null);
//         alert(
//           `Successfully ${
//             notificationId ? "updated" : "processed"
//           } notification(s).`
//         );
//       } else {
//         alert(
//           `Failed to update notifications: ${
//             response.data.message || "Unknown error"
//           }`
//         );
//       }
//     } catch (error) {
//       alert(`Error performing action: ${error.message}`);
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   const handleCancelNotification = async (notificationId) => {
//     if (isProcessing) return;
//     setIsProcessing(true);

//     try {
//       const response = await axios.put(
//         `${ApiUrl}/Api/notification.php?mode=employeUpdate`,
//         {
//           id: notificationId,
//           viewed: true,
//           updated_by: getitem,
//         }
//       );

//       if (response.data.success) {
//         await fetchNotification();
//         alert("Notification marked as viewed.");
//       } else {
//         alert(
//           `Failed to mark notification as viewed: ${
//             response.data.message || "Unknown error"
//           }`
//         );
//       }
//     } catch (error) {
//       alert(`Error marking notification as viewed: ${error.message}`);
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   return (
//     <div className="navbar">
//       <div className="navbar-left">
//         <div className="navbar-route">
//           <span className="dashboard-text">Dashboard</span>
//           <span className="separator">/</span>
//           <span className="purchase-text">{getPageTitle()}</span>
//         </div>
//       </div>
//       <div className="navbar-right">
//         <div className="price-badge gold">
//           <img
//             src={require("../../assets/images/gold coin.png")}
//             alt=""
//             className="coin-icon"
//           />
//           <span>₹{rates.gold_1g_rate} / 1 gram</span>
//         </div>
//         <div className="price-badge silver">
//           <img
//             src={require("../../assets/images/silver coin.png")}
//             alt=""
//             className="coin-icon"
//           />
//           <span>₹{rates.silver_10g_rate} / 1 gram</span>
//         </div>
//         {/* <button
//           className="btn btn-primary btn-sm mx-2"
//           onClick={() => navigate("/sales")}
//         >
//           Sales
//         </button> */}
//         <div className="notification-wrapper" ref={notificationsRef}>
//           <div
//             className="notification-icon"
//             onClick={() => {
//               setShowNotifications(!showNotifications);
//               setShowProfile(false);
//             }}
//           >
//             <BiBell size={20} />
//             {unreadNotificationsCount > 0 && (
//               <span className="notification-count">
//                 {unreadNotificationsCount}
//               </span>
//             )}
//           </div>
//           {showNotifications && (
//             <div className="notification-dropdown slide-in-right">
//               <div className="notification-header">
//                 <h6>Notifications</h6>
//                 <button
//                   className="btn close-btn"
//                   onClick={handleCloseNotifications}
//                   aria-label="Close notifications"
//                 >
//                   <FaTimes size={16} />
//                 </button>
//               </div>
//               {role === "Admin" && filteredNotifications.length > 0 && (
//                 <div
//                   className="bulk-actions p-2 d-flex justify-content-between align-items-center"
//                   style={{ borderBottom: "1px solid #e2e8f0" }}
//                 >
//                   <div className="checkbox-group d-flex">
//                     <label className="me-3">
//                       <input
//                         type="checkbox"
//                         checked={bulkAction === "accept"}
//                         onChange={() =>
//                           setBulkAction(
//                             bulkAction === "accept" ? null : "accept"
//                           )
//                         }
//                         disabled={isProcessing}
//                       />
//                       Accept All
//                     </label>
//                     <label>
//                       <input
//                         type="checkbox"
//                         checked={bulkAction === "reject"}
//                         onChange={() =>
//                           setBulkAction(
//                             bulkAction === "reject" ? null : "reject"
//                           )
//                         }
//                         disabled={isProcessing}
//                       />
//                       Reject All
//                     </label>
//                   </div>
//                   <button
//                     className="btn btn-primary btn-sm"
//                     onClick={() => handleBulkAction(bulkAction)}
//                     disabled={!bulkAction || isProcessing}
//                   >
//                     Confirm
//                   </button>
//                 </div>
//               )}
//               <div className="notification-content">
//                 {filteredNotifications.length > 0 ? (
//                   filteredNotifications.map((notification) => (
//                     <div
//                       className="notification-item"
//                       key={notification.id}
//                       style={{
//                         backgroundColor: getStatusBackgroundColor(
//                           notification.status
//                         ),
//                         color: "#333333",
//                         padding: "10px",
//                         marginBottom: "5px",
//                         borderRadius: "5px",
//                       }}
//                     >
//                       <div className="notification-avatar">
//                         <img
//                           src={require("../../assets/images/user_icon.png")}
//                           alt="Employee profile"
//                         />
//                       </div>
//                       <div className="notification-info">
//                         <h6 className="notification-title">
//                           {notification.employe_id || "Unknown Employee"}
//                         </h6>
//                         <p
//                           className="notification-message text-white"
//                           onClick={() =>
//                             handleNotificationClick(notification.table_name)
//                           }
//                           style={{ cursor: "pointer" }}
//                         >
//                           {notification.table_name} Request
//                         </p>
//                         <small className="notification-time">
//                           {notification.time || "No time available"}
//                         </small>
//                       </div>
//                       {role === "Admin" &&
//                         notification.status.toLowerCase() === "requested" && (
//                           <div className="notification-actions">
//                             <button
//                               className="btn bg-info action-btn share btn-sm"
//                               onClick={() =>
//                                 handleBulkAction("accept", notification.id)
//                               }
//                               disabled={isProcessing}
//                             >
//                               <TiTick />
//                             </button>
//                             <button
//                               className="action btn share btn-sm bg-light text-dark"
//                               onClick={() =>
//                                 handleBulkAction("reject", notification.id)
//                               }
//                               disabled={isProcessing}
//                             >
//                               <IoIosClose />
//                             </button>
//                           </div>
//                         )}
//                       {role === "Employee" && (
//                         <button
//                           className="btn btn-sm btn-danger text-white"
//                           onClick={() =>
//                             handleCancelNotification(notification.id)
//                           }
//                         >
//                           X
//                         </button>
//                       )}
//                     </div>
//                   ))
//                 ) : (
//                   <p className="text-center mt-3">
//                     No Notifications Available!!!!.
//                   </p>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>
//         <div className="profile-wrapper" ref={profileRef}>
//           <div
//             className="user-profile"
//             onClick={() => {
//               setShowProfile(!showProfile);
//               setShowNotifications(false);
//             }}
//           >
//             <div className="avatar">
//               <img
//                 src={require("../../assets/images/user_icon.png")}
//                 alt="User avatar"
//               />
//             </div>
//             <span className="username">{getitem}</span>
//             <span className="dropdown-icon">▼</span>
//           </div>
//           {showProfile && (
//             <div className="profile-dropdown slide-in-top p-3">
//               <div className="d-flex justify-content-center mb-3">
//                 <div
//                   className="rounded-circle overflow-hidden"
//                   style={{
//                     width: "50px",
//                     height: "50px",
//                     border: "3px solid #e2e8f0",
//                   }}
//                 >
//                   <img
//                     src={require("../../assets/images/user_icon.png")}
//                     alt="Profile"
//                     className="w-100 h-100 object-fit-cover"
//                   />
//                 </div>
//               </div>
//               <div className="profile-header text-center mb-3">
//                 <div className="profile-name fw-bold fs-6">{getitem}</div>
//                 <div className="profile-title text-muted">{role}</div>
//               </div>
//               <div
//                 className="profile-logout p-2 rounded d-flex align-items-center cursor-pointer justify-content-center"
//                 onClick={() => {
//                   localStorage.removeItem("token");
//                   localStorage.removeItem("username");
//                   localStorage.removeItem("role");
//                   window.location.href = "/";
//                 }}
//               >
//                 <i className="fa-solid fa-right-from-bracket mx-2 text-white"></i>
//                 <span className="text-white fw-medium">Log Out</span>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Navbar;

import React, { useState, useRef, useEffect, useContext } from "react";
import { BiBell } from "react-icons/bi";
import { FaTimes } from "react-icons/fa";
import { IoIosClose } from "react-icons/io";
import { TiTick } from "react-icons/ti";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiUrl from "../Environment/ApiUrl";
import { RatesContext } from "../Pages/RatesContext";
import "../../assets/css/Navbar.css";

const Navbar = ({ collapsed }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const context = useContext(RatesContext);
  const rates = context?.rates || {
    gold_1g_rate: "Loading...",
    silver_10g_rate: "Loading...",
    cold_coin_rate: "Loading...",
  };
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const notificationsRef = useRef(null);
  const profileRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationsRef.current &&
        !notificationsRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfile(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getPageTitle = () => {
    const path = location.pathname;
    if (path === "/dashboard") return "Dashboard";
    if (path === "/daily-rates") return "Daily Rates";
    if (path === "/example") return "Example";
    if (path === "/add-daily-rates") return "Add Daily Rates";
    if (path.startsWith("/update-daily-rates/")) return "Update Daily Rates";
    if (path === "/user") return "User";
    if (path === "/products") return "Products";
    if (path === "/product-item") return "Product Item";
    if (path === "/customers") return "Customers";
    if (path === "/suppliers") return "Suppliers";
    if (path === "/purchases") return "Purchases";
    if (path === "/add-purchase") return "Add Purchase";
    if (path.startsWith("/update-purchase/")) return "Update Purchase";
    if (path.startsWith("/retailers/update-retailer/"))
      return "Update Retailer";
    if (path === "/retailers") return "Retailers";
    if (path === "/add-retailer") return "Add Retailers";
    if (path === "/orders") return "Orders";
    if (path === "/add-order") return "Add Order";
    if (path.startsWith("/update-order/")) return "Update Order";
    if (path === "/sales") return "Sales";
    if (path === "/Report") return "Reports";
    if (path === "/add-sales") return "Add Sales";
    if (path.startsWith("/update-sales/")) return "Update Sales";
    if (path === "/balance/white-page-balance") return "White Page Balance";
    if (path === "/balance/blue-page-balance") return "Blue Page Balance";
    if (path === "/chit/chit-creation") return "Chit Creation";
    if (path === "/chit/chit-list") return "Chit List";
    if (path.startsWith("/chit/chit-list/payment-history/"))
      return "Chit List Payment History";
    if (path === "/loan") return "Loan";
    if (path === "/add-loan") return "Add Loan";
    if (path.startsWith("/update-loan/")) return "Update Loan";
    if (path.startsWith("/loan-history/")) return "Loan Payment History";
    if (path === "/stocks") return "Stocks";
    if (path.startsWith("/Viewstock/")) return "View Stock";
    if (path === "/add-stock") return "Add Stock";
    if (path === "/expense") return "Expense";
    if (path === "/expense-item") return "Expense Type";
    if (path === "/personal-stock") return "Personal Stock";
    if (path === "/add-personal-stock") return "Add Personal Stock";
    if (path.startsWith("/PersonalviewStock/")) return "Personal View Stock";
    if (path === "/sales-vs-expense") return "Sales vs Expense";
    if (path.startsWith("/add-sales-vs-expense/"))
      return "Update Sales vs Expense";
    if (path.startsWith("/sales-bill/")) return "Sales Bill";
    if (path.startsWith("/bill/")) return "Bill";
    if (path.startsWith("/loan/")) return "Loan Bill";
    if (path.startsWith("/order-small-bill/")) return "Order Small Bill";
    if (path.startsWith("/purchase-bill/")) return "Purchase Bill";
    if (path.startsWith("/chit-bill/")) return "Chit Bill";
    if (path.startsWith("/order-big-bill/")) return "Order Big Bill";
    if (path.startsWith("/retailer-bill/")) return "Retailer Bill";
    if (path === "/dailyrates-popup") return "Daily Rates Popup";

    return "Home";
  };

  const handleCloseNotifications = () => {
    setShowNotifications(false);
  };

  const [getitem, setItem] = useState();
  const [role, setRole] = useState();

  useEffect(() => {
    const username = localStorage.getItem("username");
    const role = localStorage.getItem("role");
    setItem(username);
    setRole(role);
  }, []);

  const [responseNotification, setResponseNotification] = useState([]);

  const fetchNotification = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/notification.php`);
      setResponseNotification(response.data?.data || []);
    } catch (error) {
      console.log("Error fetching notifications:", error.message);
    }
  };

  useEffect(() => {
    fetchNotification();
    const interval = setInterval(fetchNotification, 5000);
    return () => clearInterval(interval);
  }, []);

  const filteredNotifications = responseNotification.filter((notification) => {
    if (role === "Employee") {
      return (
        notification.employe_id === getitem &&
        (notification.status.toLowerCase() === "accepted" ||
          notification.status.toLowerCase() === "rejected")
      );
    } else if (role === "Admin") {
      return notification.status.toLowerCase() === "requested";
    }
    return false;
  });

  const unreadNotificationsCount = filteredNotifications.filter(
    (notification) => notification.viewed !== "true"
  ).length;

  const getStatusBackgroundColor = (status) => {
    switch (status.toLowerCase()) {
      case "requested":
        return "#FFC107";
      case "accepted":
        return "#4CAF50";
      case "rejected":
        return "#F44336";
      default:
        return "#FFFFFF";
    }
  };

  const handleNotificationClick = (tableName) => {
    let path;
    switch (tableName.toLowerCase()) {
      case "sales":
        path = "/sales";
        break;
      case "loan":
        path = "/loan";
        break;
      case "daily_rates":
        path = "/daily_rates";
        break;
      case "product":
        path = "/product";
        break;
      default:
        path = "/";
        break;
    }
    navigate(path);
    setShowNotifications(false);
  };

  const [bulkAction, setBulkAction] = useState(null);

  const handleBulkAction = async (action, notificationId = null) => {
    const validActions = ["accept", "reject"];
    if (!action || !validActions.includes(action)) {
      alert("Please select a valid action (Accept or Reject).");
      return;
    }

    if (!notificationId && filteredNotifications.length === 0) {
      alert("No notifications to process.");
      return;
    }

    if (isProcessing) return;
    setIsProcessing(true);

    try {
      let notificationIds = notificationId
        ? [notificationId]
        : filteredNotifications.map((notification) => notification.id);

      const response = await axios.put(`${ApiUrl}/Api/notification.php`, {
        status: action === "accept" ? "accepted" : "rejected",
        notificationIds,
        updated_by: getitem,
      });

      if (response.data.success) {
        await fetchNotification();
        if (!notificationId) setBulkAction(null);
        alert(
          `Successfully ${
            notificationId ? "updated" : "processed"
          } notification(s).`
        );
      } else {
        alert(
          `Failed to update notifications: ${
            response.data.message || "Unknown error"
          }`
        );
      }
    } catch (error) {
      alert(`Error performing action: ${error.message}`);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleCancelNotification = async (notificationId) => {
    if (isProcessing) return;
    setIsProcessing(true);

    try {
      const response = await axios.put(
        `${ApiUrl}/Api/notification.php?mode=employeUpdate`,
        {
          id: notificationId,
          viewed: true,
          updated_by: getitem,
        }
      );

      if (response.data.success) {
        await fetchNotification();
        alert("Notification marked as viewed.");
      } else {
        alert(
          `Failed to mark notification as viewed: ${
            response.data.message || "Unknown error"
          }`
        );
      }
    } catch (error) {
      alert(`Error marking notification as viewed: ${error.message}`);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="navbar">
      <div className="navbar-left">
        <div className="navbar-route">
          <span className="dashboard-text">Dashboard</span>
          <span className="separator">/</span>
          <span className="purchase-text">{getPageTitle()}</span>
        </div>
      </div>
      <div className="navbar-right">
        <div className="price-badge gold">
          <img
            src={require("../../assets/images/gold coin.png")}
            alt=""
            className="coin-icon"
          />
          <span>₹{rates.gold_1g_rate} / 1 gram</span>
        </div>
        <div className="price-badge silver">
          <img
            src={require("../../assets/images/silver coin.png")}
            alt=""
            className="coin-icon"
          />
          <span>₹{rates.silver_10g_rate} / 1 gram</span>
        </div>
        <div className="notification-wrapper" ref={notificationsRef}>
          <div
            className="notification-icon"
            onClick={() => {
              setShowNotifications(!showNotifications);
              setShowProfile(false);
            }}
          >
            <BiBell size={20} />
            {unreadNotificationsCount > 0 && (
              <span className="notification-count">
                {unreadNotificationsCount}
              </span>
            )}
          </div>
          {showNotifications && (
            <div className="notification-dropdown slide-in-right">
              <div className="notification-header">
                <h6>Notifications</h6>
                <button
                  className="btn close-btn"
                  onClick={handleCloseNotifications}
                  aria-label="Close notifications"
                >
                  <FaTimes size={16} />
                </button>
              </div>
              {role === "Admin" && filteredNotifications.length > 0 && (
                <div
                  className="bulk-actions p-2 d-flex justify-content-between align-items-center"
                  style={{ borderBottom: "1px solid #e2e8f0" }}
                >
                  <div className="checkbox-group d-flex">
                    <label className="me-3">
                      <input
                        type="checkbox"
                        checked={bulkAction === "accept"}
                        onChange={() =>
                          setBulkAction(
                            bulkAction === "accept" ? null : "accept"
                          )
                        }
                        disabled={isProcessing}
                      />
                      Accept All
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        checked={bulkAction === "reject"}
                        onChange={() =>
                          setBulkAction(
                            bulkAction === "reject" ? null : "reject"
                          )
                        }
                        disabled={isProcessing}
                      />
                      Reject All
                    </label>
                  </div>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => handleBulkAction(bulkAction)}
                    disabled={!bulkAction || isProcessing}
                  >
                    Confirm
                  </button>
                </div>
              )}
              <div className="notification-content">
                {filteredNotifications.length > 0 ? (
                  filteredNotifications.map((notification) => (
                    <div
                      className="notification-item"
                      key={notification.id}
                      style={{
                        backgroundColor: getStatusBackgroundColor(
                          notification.status
                        ),
                        color: "#333333",
                        padding: "10px",
                        marginBottom: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="notification-avatar">
                        <img
                          src={require("../../assets/images/user_icon.png")}
                          alt="Employee profile"
                        />
                      </div>
                      <div className="notification-info">
                        <h6 className="notification-title">
                          {notification.employe_id || "Unknown Employee"}
                        </h6>
                        <p
                          className="notification-message text-white"
                          onClick={() =>
                            handleNotificationClick(notification.table_name)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          {notification.table_name} Request
                        </p>
                        <small className="notification-time">
                          {notification.time || "No time available"}
                        </small>
                      </div>
                      {role === "Admin" &&
                        notification.status.toLowerCase() === "requested" && (
                          <div className="notification-actions">
                            <button
                              className="btn bg-info action-btn share btn-sm"
                              onClick={() =>
                                handleBulkAction("accept", notification.id)
                              }
                              disabled={isProcessing}
                            >
                              <TiTick />
                            </button>
                            <button
                              className="action btn share btn-sm bg-light text-dark"
                              onClick={() =>
                                handleBulkAction("reject", notification.id)
                              }
                              disabled={isProcessing}
                            >
                              <IoIosClose />
                            </button>
                          </div>
                        )}
                      {role === "Employee" && (
                        <button
                          className="btn btn-sm btn-danger text-white"
                          onClick={() =>
                            handleCancelNotification(notification.id)
                          }
                        >
                          X
                        </button>
                      )}
                    </div>
                  ))
                ) : (
                  <p className="text-center mt-3">
                    No Notifications Available!!!!.
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="profile-wrapper" ref={profileRef}>
          <div
            className="user-profile"
            onClick={() => {
              setShowProfile(!showProfile);
              setShowNotifications(false);
            }}
          >
            <div className="avatar">
              <img
                src={require("../../assets/images/user_icon.png")}
                alt="User avatar"
              />
            </div>
            <span className="username">{getitem}</span>
            <span className="dropdown-icon">▼</span>
          </div>
          {showProfile && (
            <div className="profile-dropdown slide-in-top p-3">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="rounded-circle overflow-hidden"
                  style={{
                    width: "50px",
                    height: "50px",
                    border: "3px solid #e2e8f0",
                  }}
                >
                  <img
                    src={require("../../assets/images/user_icon.png")}
                    alt="Profile"
                    className="w-100 h-100 object-fit-cover"
                  />
                </div>
              </div>
              <div className="profile-header text-center mb-3">
                <div className="profile-name fw-bold fs-6">{getitem}</div>
                <div className="profile-title text-muted">{role}</div>
              </div>
              <div
                className="profile-logout p-2 rounded d-flex align-items-center cursor-pointer justify-content-center"
                onClick={() => {
                  localStorage.removeItem("token");
                  localStorage.removeItem("username");
                  localStorage.removeItem("role");
                  window.location.href = "/";
                }}
              >
                <i className="fa-solid fa-right-from-bracket mx-2 text-white"></i>
                <span className="text-white fw-medium">Log Out</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
